import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import { Card } from "react-bootstrap";

ChartJS.register(ArcElement, Tooltip, Legend);

export type PieChartProps = {
  width?: string;
  chartTitle: string;
  labels: string[];
  chartData: DoughnutChartData;
};

export interface DoughnutChartData {
  data: number[];
  borderColor: string[];
  backgroundColor: string[];
}

export function PieChart({
  width,
  chartTitle,
  labels,
  chartData,
}: PieChartProps) {
  const data = {
    labels,
    datasets: [
      {
        label: `Events`,
        data: chartData?.data ?? [],
        backgroundColor: chartData?.backgroundColor ?? [],
        borderColor: chartData?.borderColor ?? [],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom" as const,
      },
      title: {
        display: true,
        text: chartTitle,
      },
    },
  };

  return (
    <Card style={{ backgroundColor: "#f8f9fa", width: width, height: width }}>
      <Card.Body>
        <Pie data={data} options={options} />
      </Card.Body>
    </Card>
  );
}
